import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-billing-promo",
  "use": "icon-soc-billing-promo-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-billing-promo\">\n<g fill=\"currentColor\">\n  <rect x=\"160\" y=\"200\" width=\"280\" height=\"520\" rx=\"24\" opacity=\"0.18\" />\n  <rect x=\"200\" y=\"260\" width=\"200\" height=\"48\" rx=\"12\" />\n  <rect x=\"200\" y=\"340\" width=\"160\" height=\"32\" rx=\"8\" opacity=\"0.65\" />\n  <rect x=\"200\" y=\"400\" width=\"180\" height=\"32\" rx=\"8\" opacity=\"0.5\" />\n  <path d=\"M520 280h280v96H520z\" opacity=\"0.25\" />\n  <path d=\"M520 420h220v56H520z\" rx=\"12\" />\n  <path d=\"M520 520h260v56H520z\" rx=\"12\" opacity=\"0.75\" />\n  <circle cx=\"760\" cy=\"680\" r=\"88\" opacity=\"0.85\" />\n  <path d=\"M724 680h72M760 644v72\" stroke=\"#fff\" stroke-width=\"28\" stroke-linecap=\"round\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-billing-promo.svg
// module id = l7Ro
// module chunks = 492